import { twMerge } from "tailwind-merge"
import Button from "./Button"

export interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: "green" | "purple"
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ className, theme = "green", ...props }) => {
  return (
    <Button
      className={twMerge(
        "block w-full rounded-xl bg-purple font-bricolage text-[1.625rem] py-[0.6rem] text-center font-extrabold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
        className,
      )}
      {...props}
    />
  )
}

export default PrimaryButton
